import React from 'react';
import { ProjectRow } from '../../lib/types';

interface PortfolioBoardProps {
  projects: ProjectRow[];
  onSelectProject: (id: string | null) => void;
}

const PORTFOLIO_COLUMNS = [
  {
    id: 'validation',
    title: 'In Validation',
    description: 'User research and prototyping',
    statuses: ['InValidation'] as const,
  },
  {
    id: 'planning',
    title: 'In Planning',
    description: 'Business case and resource planning',
    statuses: ['InPlanning'] as const,
  },
  {
    id: 'ready',
    title: 'Ready for Delivery',
    description: 'Approved and ready to start work',
    statuses: ['ReadyForDelivery'] as const,
  },
  {
    id: 'delivery',
    title: 'In Delivery',
    description: 'Active development and execution',
    statuses: ['InDelivery'] as const,
  },
  {
    id: 'complete',
    title: 'Complete',
    description: 'Delivered and closed',
    statuses: ['Complete'] as const,
  },
];

export function PortfolioBoard({ projects, onSelectProject }: PortfolioBoardProps) {
  const getProjectsForColumn = (statuses: readonly string[]): ProjectRow[] => {
    return projects.filter(p => statuses.includes(p.Status));
  };

  return (
    <div className="portfolio-board">
      {PORTFOLIO_COLUMNS.map(column => (
        <div key={column.id} className="portfolio-column">
          <div className="column-header">
            <h3>{column.title}</h3>
            <span className="column-count">
              {getProjectsForColumn(column.statuses).length}
            </span>
          </div>
          <p className="column-description">{column.description}</p>
          <div className="column-cards">
            {getProjectsForColumn(column.statuses).map(project => (
              <div
                key={project.ProjectId}
                className="project-card"
                onClick={() => onSelectProject(project.ProjectId)}
                role="button"
                tabIndex={0}
              >
                <div className="card-header">
                  <span className="card-id">{project.ProjectId}</span>
                  {project.Priority && <span className="card-priority">{project.Priority}</span>}
                </div>
                <h4 className="card-title">{project.Title}</h4>
                <div className="card-meta">
                  <span className="card-domain">{project.Domain}</span>
                  <span className="card-type">{project.WorkType}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
